<template>
  <ul class="mt-4 mb-5">
    <li v-for="(bullet, i) in bullets.slice(0, 3)" :key="i" class="text-white">
      {{ bullet }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Product, ProductFeatures } from '~/types';

defineProps<{
  product: Product;
  bullets: ProductFeatures['bullets'];
}>();
</script>

<style lang="scss" scoped>
li {
  list-style: none;
  margin-inline-start: 0;
  margin-bottom: var(--space-4);
  font-size: 16px;
  text-align: center;
}
@media (max-width: 850px) {
  ul {
    display: flex;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    gap: var(--space-1);
    li {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}
</style>